import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Signal,
} from '@angular/core';
import {
  IonButton,
  IonButtons,
  IonHeader,
  IonIcon,
  IonTitle,
  IonToolbar,
} from '@ionic/angular/standalone';

import { AuthFacade } from '@lyceo/shared/auth/data-access';
import { addIcons } from 'ionicons';
import { logOutOutline, informationCircleOutline } from 'ionicons/icons';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  imports: [IonHeader, IonToolbar, IonButtons, IonButton, IonTitle, IonIcon],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {
  private readonly authFacade: AuthFacade = inject(AuthFacade);

  public readonly isAuthenticated: Signal<boolean> =
    this.authFacade.isAuthenticated;

  constructor() {
    addIcons({ logOutOutline, informationCircleOutline });
  }

  public logout(): void {
    this.authFacade.userLogout();
  }
}
